<div *ngIf="section == 'intro'">

  <h1>
    <code>TemplateRef</code> fails in <code>table</code>
  </h1>

</div>



<div *ngIf="section == 'default'">
  <h2>default</h2>
</div>



<div *ngIf="section == 'custom'">
  <h2>custom</h2>
  <p>
    This is like the last example in the branch <a href="/#/13">before</a>.<br>
  </p>
  <p class="problem">
    The right header and body cells are not aligned, because in the body there is an <code>&lt;app-blog-list&gt;</code> between <code>&lt;table&gt;</code> and <code>&lt;tr&gt;</code>.
  </p>
</div>
